import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';
import { theme } from '~/theme';

export const StyledContentMap = styled.div<{ hide?: boolean }>(({ hide }) => ({
    width: '100%',
    display: hide ? 'none' : 'flex',
    marginBottom: theme.space[7],
}));

export const StyledMap = styled.div(() => ({
    display: 'none',
    '.mapHelper__cluster': {
        backgroundColor: `${theme.colors.white}`,
        borderRadius: theme.space[6],
    },
    [breakpoints.md]: {
        display: 'block',
        width: '100%',
    },
}));
export const StyledMapList = styled.div(() => ({
    width: '100%',
    [breakpoints.md]: {
        display: 'block',
        width: '100%',
    },
}));
export const StyledInputFieldWrapper = styled.div(() => ({
    position: 'relative',
    flexDirection: 'row',
    display: 'flex',
    borderRadius: theme.sizes.cornerRadiusLarge,
    alignItems: 'center',
    marginTop: theme.space[1],
    marginBottom: theme.space[1],

    border: `1px solid ${theme.colors.black}`,
    backgroundColor: theme.colors.white,
    [`&:active ${StyledLabel}`]: {
        color: theme.colors.black,
    },
}));

export const StyledLi = styled.li(() => ({
    width: '100%',
    listStyle: 'none',
    padding: theme.space[3],
    borderBottom: `1px solid ${theme.colors.brownLight}`,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    background: theme.colors.white,
}));

export const StyledInput = styled.input(() => ({
    ...theme.mixins.useTextStyle('formInput'),
    borderRadius: theme.sizes.cornerRadius,
    height: 40,
    color: theme.colors.black,
    border: 2,
    lineHeight: theme.lineHeights.single,
    position: 'relative',
    cursor: 'type',
    outline: 0,
    width: '100px',
    boxSizing: 'border-box',
    textAlign: 'left',
    display: 'block',
    padding: `0 ${theme.space[3]}`,
    '&::placeholder': {
        transition: '0.1s color',
        color: theme.colors.grey70,
    },
    '&:empty:placeholder-shown::placeholder': {
        color: 'transparent',
    },
    '&:focus:empty::placeholder': {
        color: theme.colors.grey70,
    },
    '&:not(:placeholder-shown) + label, &:focus + label': {
        backgroundColor: theme.colors.white,
        paddingLeft: theme.space[1],
        paddingRight: theme.space[1],
        transform: 'translateY(-30px)',
        ...theme.mixins.useTextStyle('formsLabelActive'),
    },
}));

export const StyledLabel = styled.label(() => ({
    position: 'absolute',
    top: '50%',
    left: theme.space[3],
    ...theme.mixins.useTextStyle('formsLabel'),
    transition: '0.1s transform, 0.1s width',
    color: theme.colors.black,
    transform: 'translateY(-50%)',
    maxWidth: `calc(100% - ${theme.space[3]} - ${theme.space[3]})`,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    transformOrigin: 'left top',
    pointerEvents: 'none',
}));
export const StyledWrapper = styled.div(() => ({
    position: 'relative',
    flexGrow: 1,
}));
